module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Français"},"en":{"a":"Anglais"}}')
  delete Component.options._Ctor
}
